import { Typography, Grid, Card } from '@mui/material';

const ConfirmationMenssage = () => {
  return (
    <Grid
      container
      style={{
        height: '100%',
        minHeight: '80vh',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
      className='bg-background'
    >
      {/*
        La tarjeta combinaba un navy propio, un radio de 10px a mano y una
        sombra suelta, y ademas le habian puesto `bg-gray-950` (que no pintaba
        nada). Ahora superficie, radio y sombra salen del tema.
      */}
      <Card
        style={{
          padding: '20px',
          lineHeight: '1.6',
          // En `style` y no en className: `Card` ya trae fondo, radio y sombra
          // desde el tema y ganaria por especificidad.
          borderRadius: 'var(--radius)',
          boxShadow: 'var(--shadow)',
        }}
      >
        <Typography
          variant='h6'
          align='center'
          gutterBottom
        >
          Great news – your application is in the review stage. We're thrilled about the prospect of
          having you on board and are eager to offer you a top-notch digital transaction experience.
          Stay tuned! We'll keep you updated on the progress of your merchant application and will
          notify you as soon as a decision is made. Thank you for choosing us, and we're excited
          about the journey ahead! Warm regards
        </Typography>
      </Card>
    </Grid>
  );
};

export default ConfirmationMenssage;
